{
  "preferences_theme_header": "Tema",
  "preferences_theme_auto_title": "Tema Automático",
  "preferences_theme_auto_description": "Cambia automáticamente con tu dispositivo.",
  "preferences_theme_default_title": "Tema Predeterminado",
  "preferences_theme_default_description": "El hermoso tema predeterminado para Dabble.",
  "preferences_theme_dark_title": "Tema Oscuro",
  "preferences_theme_dark_description": "Para escribir de noche y mejor empollando."
}